/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request body for bulk starting bots by group IDs and users count
 * @export
 * @interface BulkStartBotRequest
 */
export interface BulkStartBotRequest {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof BulkStartBotRequest
     */
    groupIdsToUsersCount: { [key: string]: number; };
}

/**
 * Check if a given object implements the BulkStartBotRequest interface.
 */
export function instanceOfBulkStartBotRequest(value: object): value is BulkStartBotRequest {
    if (!('groupIdsToUsersCount' in value) || value['groupIdsToUsersCount'] === undefined) return false;
    return true;
}

export function BulkStartBotRequestFromJSON(json: any): BulkStartBotRequest {
    return BulkStartBotRequestFromJSONTyped(json, false);
}

export function BulkStartBotRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkStartBotRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'groupIdsToUsersCount': json['group_ids_to_users_count'],
    };
}

export function BulkStartBotRequestToJSON(json: any): BulkStartBotRequest {
    return BulkStartBotRequestToJSONTyped(json, false);
}

export function BulkStartBotRequestToJSONTyped(value?: BulkStartBotRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'group_ids_to_users_count': value['groupIdsToUsersCount'],
    };
}

